import {WeaTools} from 'ecCom';

// 检查是否部署了CAS
export const checkCasIsDeployed = (params = {}) => WeaTools.callApi('/api/integration/common1/checkCasIsDeployed', 'POST', params);
// 获取升级信息
export const getUpgradeInfo = (params = {}) => WeaTools.callApi('/login/UpgradeMessage.jsp?getupgradeinfo=1', 'GET', params);
// 获取登录信息
export const getLoginInfo = (params = {}) => WeaTools.callApi('/api/portal/login/logininfo', 'POST', params);
// 获取使用的语言
export const getActiveLanguage = (params = {}) => WeaTools.callApi('/api/system/language/base/getActiveLanguage', 'GET', params);
// 扫码登录
export const login4qc = (params = {}) => WeaTools.callApi('/api/hrm/login/qrcode/getQCLoginStatus', 'POST', params);
// 退出
export const logout = (params = {}) => WeaTools.callApi('/api/hrm/login/checkLogout', 'POST', params);


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/apis/login.js